import React, { createContext, useContext, useState } from 'react'

const OfflineContext = createContext()
const useOfflineContext = () => useContext(OfflineContext)

const APP_STORAGE_KEY = 'APP'

const DEFAULT_STATE = {

}

const getLocalStorageState = () => {
    return JSON.parse(localStorage.getItem('APP'))
}

const updateAppLocalStorage = (value) => {
    try {
        localStorage.setItem(APP_STORAGE_KEY, JSON.stringify(value))
    } catch (error) {
        console.log(error)
    }
}

const useContextValue = () => {
    const [localState, updateLocalState] = useState(getLocalStorageState() || DEFAULT_STATE)
    const [isOnline, setIsOnline] = useState(localState.isOnline || true)
    const [showOfflineDialog, setShowOfflineDialog] = useState(false)
    const [showGoOnlineDialog, setGoOnlineDialog] = useState(false)
    const [networkError, setNetworkError] = useState(null)


    const setLocalState = (value) => {
        updateLocalState(value)
        updateAppLocalStorage(value)
    }

    const _setNetworkError = (value) => {
        if (isOnline) {
            setNetworkError(value)
        }
    }

    return {
        localState,
        setLocalState,
        isOnline,
        setIsOnline,
        showOfflineDialog,
        setShowOfflineDialog,
        showGoOnlineDialog,
        setGoOnlineDialog,
        networkError,
        setNetworkError: _setNetworkError,
        rawSetNetworkError: setNetworkError
    }
}

export const OfflineProvider = ({ children }) => {
    const ctx = useContextValue()
    return (
        <OfflineContext.Provider value={ctx}>
            {children}
        </OfflineContext.Provider>
    )
}

export const useLocalStorage = () => {
    const { localState, setLocalState } = useOfflineContext()

    const setLocalStorage = (data) => {
        let localStorageValues = localState

        let keys = Object.keys(data)
        keys.forEach(k => localStorageValues[k] = data[k])

        setLocalState(localStorageValues)
    }

    const setMutatedStorage = (key, data) => { // consider moving this to a separate KEY altogether
        let localStorageValues = localState
        localStorageValues[key] = data

        setLocalState(localStorageValues)
    }

    const deleteLocalKey = (key) => {
        let localStorageValues = localState
        if (localStorageValues.hasOwnProperty(key)) {
            delete localStorageValues[key]
        }

        setLocalState(localStorageValues)
    }

    const clearAppStorage = () => {
        setLocalState({})
    }

    const removeOfflineChanges = () => {
        let localStorageValues = localState
        const keysToRemove = Object.keys(localState).filter(k => k.indexOf(':') !== -1)
        keysToRemove.forEach(k => delete localStorageValues[k])
        setLocalState(localStorageValues)
    }

    return {
        localState,
        setLocalStorage,
        setMutatedStorage,
        deleteLocalKey,
        clearAppStorage,
        removeOfflineChanges
    }
}

export const useOnlineUtils = () => {
    const { isOnline, setIsOnline, showOfflineDialog, setShowOfflineDialog,
        showGoOnlineDialog, setGoOnlineDialog,
        networkError, setNetworkError, rawSetNetworkError
    } = useOfflineContext()
    return {
        isOnline,
        setIsOnline, // replace with goOnline / goOffline?
        showOfflineDialog,
        setShowOfflineDialog,  // replace
        showGoOnlineDialog,
        setGoOnlineDialog,
        networkError,
        setNetworkError,
        rawSetNetworkError
    }
}